import { useCallback } from 'react';
import { useLoaderAction } from '../common/busy-indicator-provider/busy-indicator-context';
import { AsyncCallbackMiddlewareProvider } from '../common/custom-hooks/use-async-callback';
import { useNotifications } from '../common/notification-provider/notification-provider';

/**
 * ApplicationContainer specific implementation of AsyncCallbackMiddlewareProvider. It does two things:
 *
 * - global spinner will be displayed
 * - show error notifications in case of an exception (and pass the exception through)
 */
export const ApplicationAsyncCallbackMiddlewareProvider = ({ children }) => {
  const setLoader = useLoaderAction();
  const { showNotification } = useNotifications();
  const wrapAsyncCallback = useCallback((asyncFunction, options = {}) => async (...args) => {
    if (!options.noBusyLoader) {
      setLoader(true);
    }
    try {
      return await asyncFunction(...args);
    } catch (error) {
      /** Below condition is temporary fix for not displaying 401 notification message */
      if (error.statusCode === 401) {
        options.noErrorHandling = true;
      }
      if (options.noErrorHandling) {
        throw error;
      } else {
        showNotification({
          title: error.message || 'Oeps dit was niet de bedoeling! Neem contact op met de helpdesk wanneer dit probleem zich blijft voordoen',
          type: 'warning',
          showCloseButton: true,
        });
        return undefined;
      }
    } finally {
      if (!options.noBusyLoader) {
        setLoader(false);
      }
    }
  }, [setLoader, showNotification]);

  return <AsyncCallbackMiddlewareProvider wrap={wrapAsyncCallback}>{children}</AsyncCallbackMiddlewareProvider>;
};
